import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Header from './components/Header';
import Footer from './components/Footer';
import NoMatch from './components/NoMatch';

const HomeScreen = lazy(() => import('./screens/HomeScreen'));
const AboutScreen = lazy(() => import('./screens/AboutScreen'));
const ProjectsScreen = lazy(() => import('./screens/ProjectsScreen'));
const ProjectDetailScreen = lazy(() => import('./screens/ProjectDetailScreen'));
const ServiceScreen = lazy(() => import('./screens/ServiceScreen'));
const ContactScreen = lazy(() => import('./screens/ContactScreen'));
const ServiceDetailScreen = lazy(() => import('./screens/ServiceDetailScreen'));
const LeadScreen = lazy(() => import('./screens/LeadScreen'));

const App = React.memo(() => {
  return (
    <Router>
      <Header />
      <Container fluid className='p-0 mt-5'>
        <Suspense fallback={<div style={{ minHeight: '60vh' }} />}>
          <Switch>
            <Route path='/' exact component={HomeScreen} />
            <Route path='/about' exact component={AboutScreen} />
            <Route path='/projects' exact component={ProjectsScreen} />
            <Route path='/projects/:id' component={ProjectDetailScreen} />
            <Route path='/lead-based-paint' exact component={LeadScreen} />
            <Route path='/services' exact component={ServiceScreen} />
            <Route path='/services/:id' component={ServiceDetailScreen} />
            <Route path='/contact' exact component={ContactScreen} />
            <Route component={NoMatch} />
          </Switch>
        </Suspense>
      </Container>
      <Footer />
    </Router>
  );
});

export default App;
